import { render, staticRenderFns } from "./purchaseDevice-add-or-update.vue?vue&type=template&id=4ccbc1fb&scoped=true"
import script from "./purchaseDevice-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseDevice-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseDevice-add-or-update.vue?vue&type=style&index=0&id=4ccbc1fb&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbc1fb",
  null
  
)

export default component.exports